/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface AgreementBase
 */
export interface AgreementBaseOptional {
  /**
   *
   * @type {string}
   * @memberof AgreementBase
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementBase
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementBase
   */
  sortOrder?: number;
}

export interface AgreementBase extends AgreementBaseOptional {
  /**
   *
   * @type {string}
   * @memberof AgreementBase
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementBase
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementBase
   */
  sortOrder?: number;
}

export interface AgreementBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof AgreementBase
   */
  agreementName?: string;
  agreementNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementBase
   */
  isGlobal?: boolean;
  isGlobalIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementBase
   */
  sortOrder?: number;
  sortOrderIsSet: boolean;
}

transformDatesMap.set("AgreementBase", function (model: AgreementBase) {});

export type AgreementBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  agreementName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isGlobal: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  sortOrder: PropertyMeta<MetaTypeBase<number>>;
}>;

export var AgreementBaseMeta: AgreementBaseMetaI = {} as AgreementBaseMetaI;
AgreementBaseMeta = typeMeta("AgreementBase", {
  agreementName: propertyMeta(
    "agreementName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isGlobal: propertyMeta(
    "isGlobal",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  sortOrder: propertyMeta(
    "sortOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = AgreementBaseMeta;

registerMeta(() => {});

export class AgreementBaseTracked implements AgreementBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  agreementName__I?: string = undefined;
  agreementNameIsSet: boolean = false;
  set agreementName(v: undefined | string) {
    if (v !== undefined) {
      this.agreementName__I = v;
      this.agreementNameIsSet = true;
    } else {
      this.agreementName__I = v || undefined;
      this.agreementNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementName() {
    return this.agreementName__I;
  }
  isGlobal__I?: boolean = undefined;
  isGlobalIsSet: boolean = false;
  set isGlobal(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGlobal__I = v;
      this.isGlobalIsSet = true;
    } else {
      this.isGlobal__I = v || undefined;
      this.isGlobalIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGlobal() {
    return this.isGlobal__I;
  }
  sortOrder__I?: number = undefined;
  sortOrderIsSet: boolean = false;
  set sortOrder(v: undefined | number) {
    if (v !== undefined) {
      this.sortOrder__I = v;
      this.sortOrderIsSet = true;
    } else {
      this.sortOrder__I = v || undefined;
      this.sortOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get sortOrder() {
    return this.sortOrder__I;
  }
  constructor(config?: AgreementBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: AgreementBaseOptional,
    options?: AssignOptions,
  ): AgreementBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.agreementName &&
      this.agreementNameApplyFilter(optionsRequired.filter)
    ) {
      this.agreementName = config.agreementName;
      if (optionsRequired.unassign) this.agreementNameIsSet = false;
      else this.agreementNameIsSet = true;
    }
    if (config.isGlobal && this.isGlobalApplyFilter(optionsRequired.filter)) {
      this.isGlobal = config.isGlobal;
      if (optionsRequired.unassign) this.isGlobalIsSet = false;
      else this.isGlobalIsSet = true;
    }
    if (config.sortOrder && this.sortOrderApplyFilter(optionsRequired.filter)) {
      this.sortOrder = config.sortOrder;
      if (optionsRequired.unassign) this.sortOrderIsSet = false;
      else this.sortOrderIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementBaseTrackedI {
    const cloned = {} as AgreementBaseTrackedI;
    if (
      this.agreementNameIsSetDeep() &&
      this.agreementNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementNameIsSet = true;
      cloned.agreementName = this.agreementName;
    } else {
      //cloned.agreementNameIsSet = false
    }
    if (
      this.isGlobalIsSetDeep() &&
      this.isGlobalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGlobalIsSet = true;
      cloned.isGlobal = this.isGlobal;
    } else {
      //cloned.isGlobalIsSet = false
    }
    if (
      this.sortOrderIsSetDeep() &&
      this.sortOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sortOrderIsSet = true;
      cloned.sortOrder = this.sortOrder;
    } else {
      //cloned.sortOrderIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementBaseTrackedI {
    if (!this.agreementNameApplyFilter(filter)) this.agreementNameIsSet = false;

    if (!this.isGlobalApplyFilter(filter)) this.isGlobalIsSet = false;

    if (!this.sortOrderApplyFilter(filter)) this.sortOrderIsSet = false;

    return this;
  }
  agreementNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseMeta.agreementName,
      AgreementBaseMeta,
      this.agreementName,
      this,
    );
  }
  agreementNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementNameIsSet && this.agreementNameApplyFilter(filter))
      return true;

    return false;
  }
  isGlobalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseMeta.isGlobal,
      AgreementBaseMeta,
      this.isGlobal,
      this,
    );
  }
  isGlobalIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGlobalIsSet && this.isGlobalApplyFilter(filter)) return true;

    return false;
  }
  sortOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseMeta.sortOrder,
      AgreementBaseMeta,
      this.sortOrder,
      this,
    );
  }
  sortOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sortOrderIsSet && this.sortOrderApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.agreementNameIsSetDeep(filter)) return true;
    if (this.isGlobalIsSetDeep(filter)) return true;
    if (this.sortOrderIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
